// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"d4a78450","158":"1102420c","308":"fe2595a6","512":"ca34f5db","523":"b0913872","618":"e93a7a31","828":"c14eac16"}[chunkId] + ".chunk.js";
};